export const ROLES = {
  STAFF: 'staff',
  SITE_ADMIN: 'site-admin',
  KITE_ADMIN: 'kite-admin',
  SITE_CONSOLE: 'site-console',
  ADMIN: 'admin',
  GUEST: 'guest'
};

const ROLE_LABELS = {
  [ROLES.SITE_ADMIN]: 'site manager',
  [ROLES.KITE_ADMIN]: 'kite manager',
  [ROLES.SITE_CONSOLE]: 'staff public ipad'
};

export const getRoleLabel = role => ROLE_LABELS[role] || role;

export const TIERS = {
  FREE: 'Free',
  MIDDLE: 'Middle',
  PREMIUM: 'Premium'
};

export const TEAM_ASSOCIATIONS = ['Staff', 'Contractor', 'Partner'];
